import { render, staticRenderFns } from "./DialogueB2C.vue?vue&type=template&id=29d42785&"
import script from "./DialogueB2C.vue?vue&type=script&lang=js&"
export * from "./DialogueB2C.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports